import type { Client, SourceStatus, ViewId } from "./types";
import {
  Activity,
  BarChart3,
  Building2,
  CalendarDays,
  ClipboardList,
  CreditCard,
  LayoutDashboard,
  Settings2,
  Soup,
  UsersRound,
} from "lucide-react";

export const navigation: Array<{
  id: ViewId;
  number: string;
  label: string;
  eyebrow: string;
  title: string;
  icon: typeof Activity;
}> = [
  { id: "control", number: "01", label: "오늘의 관제", eyebrow: "운영 관제", title: "오늘의 운영 상황", icon: LayoutDashboard },
  { id: "live", number: "02", label: "실시간 식수", eyebrow: "식권 이벤트", title: "실시간 식수 흐름", icon: Activity },
  { id: "sales", number: "03", label: "매출 분석", eyebrow: "매출 관리", title: "코너별 매출 분석", icon: BarChart3 },
  { id: "clients", number: "04", label: "고객사·팀", eyebrow: "고객사 관리", title: "고객사·팀 식수 동향", icon: Building2 },
  { id: "lunchbox", number: "05", label: "도시락", eyebrow: "주문 운영", title: "도시락 주문 운영", icon: Soup },
  { id: "staff", number: "06", label: "직원·카드 관리", eyebrow: "사용자 관리", title: "직원·카드 통합관리", icon: CreditCard },
  { id: "forecast", number: "07", label: "식수 예측", eyebrow: "수요 예측", title: "오늘 중식·석식 예측", icon: BarChart3 },
  { id: "menu", number: "08", label: "월간 식단표", eyebrow: "한식부페 식단", title: "계절 맞춤 월간 식단표", icon: CalendarDays },
  { id: "settlement", number: "09", label: "월 정산", eyebrow: "정산 관리", title: "고객사 월 정산", icon: ClipboardList },
  { id: "system", number: "10", label: "시스템 상태", eyebrow: "운영 상태", title: "데이터 수집 상태", icon: Settings2 },
];

export const clients: Client[] = [
  { id: "samyung", name: "삼영기업", teams: ["관리부", "이종헌팀", "유성복팀", "신봉교팀", "김창범팀", "김태우팀"] },
  { id: "minsung", name: "(주)민성", teams: ["관리자", "박상국팀", "최효남팀", "김인선팀", "민성소방전기", "이석주팀"] },
  { id: "tosu", name: "토수종합건설(주)", teams: ["토수관리자", "토수기술인"] },
  { id: "dongbu", name: "동부", teams: ["동부 관리", "동부 철골팀"] },
  { id: "dengineering", name: "디엔지니어링", teams: [] },
  { id: "gagyeong", name: "가경코스모", teams: [] },
];

export const terminalGroups = [
  { ids: "111·112·113", label: "한식부페", tone: "green" },
  { ids: "114", label: "해장밥상", tone: "amber" },
  { ids: "115", label: "중화요리", tone: "red" },
] as const;

export const initialSources: SourceStatus[] = [
  { id: "gateway", label: "단일 수집 관문", state: "waiting", updatedAt: null, message: "첫 스냅샷 수신 대기" },
  { id: "sdk", label: "식권 SDK", state: "waiting", updatedAt: null, message: "공식 SDK 연결 대기" },
  { id: "sql", label: "식권 SQL", state: "waiting", updatedAt: null, message: "읽기 전용 원장 연결 대기" },
  { id: "lunchbox", label: "도시락", state: "waiting", updatedAt: null, message: "주문 원장 연결 대기" },
  { id: "pos", label: "POS", state: "waiting", updatedAt: null, message: "집계 원천 연결 대기" },
  { id: "kis", label: "KIS", state: "waiting", updatedAt: null, message: "승인 합계 연결 대기" },
];

export const stateLabel = {
  connected: "실시간 연결",
  delayed: "지연",
  waiting: "연결 대기",
  error: "확인 필요",
} as const;

export const viewFromLocation = (): ViewId => {
  const value = new URLSearchParams(window.location.search).get("view") as ViewId | null;
  return navigation.some((item) => item.id === value) ? (value as ViewId) : "control";
};

export const iconForPeople = UsersRound;
